import { createAsyncThunk } from '@reduxjs/toolkit'
import { types } from '@concordia/super-sdk'
import { SDK_CONTEXT } from 'state/context'
import { isEmptyOrNil } from 'toolbox/account'

const MAX_ATTEMPTS = 5

export const fetchBrokers = createAsyncThunk(
  'brokers/fetchAll',
  async (): Promise<types.SBroker[]> => {
    const sdk = SDK_CONTEXT.superSdk
    if (!sdk) {
      throw new Error('SDK not provided')
    }

    let attempt = 0

    const baseDelay = 1000

    while (attempt < MAX_ATTEMPTS) {
      try {
        const brokers = await sdk.fetcher.fetchBrokers()
        console.log('Brokers: ', brokers)
        if (isEmptyOrNil(brokers)) {
          throw new Error('Failed to fetch brokers')
        }
        return brokers
      } catch (e: any) {
        attempt++
        console.log(`Attempt ${attempt}: Failed to fetch brokers, retrying...`)

        if (attempt >= MAX_ATTEMPTS) {
          throw new Error(e.message || 'Failed to fetch brokers after multiple attempts')
        }

        const delay = baseDelay * Math.pow(2, attempt - 1) // Exponential backoff formula
        console.log(`Waiting ${delay} ms before next attempt...`)

        await new Promise((resolve) => setTimeout(resolve, delay))
      }
    }
  }
)
